// extracted by mini-css-extract-plugin
export default {"root":"ContentInfo_root__yRO-v","title":"ContentInfo_title__ehDNU","info":"ContentInfo_info__3ALe-","striped":"ContentInfo_striped__XanTC"};